import { useState } from "react";

import Typography from "@mui/material/Typography";

import LoadingButton from "../Components/LoadingButton";

import { useAuth } from "../hooks/useAuth";
import useMessages from "../hooks/useMessages";
import usePageTitle from "../hooks/usePageTitle";

function Contact() {
  const { authed, profile } = useAuth();
  const { createMessage, error } = useMessages();

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setDisabled(true);

    const data = {
      title: title,
      body: message,
    };

    createMessage(data).then(async () => {
      setMessageSent(true);
    });
  };

  usePageTitle(`Contact | Fudopia | Meet. Eat. Repeat.`);

  return (
    <div>
      {error && <p className="error-message">Something went wrong...</p>}
      <Typography variant="h1" component="div" sx={{ flexGrow: 0 }}>
        Contact Us
      </Typography>
      {authed && !messageSent && (
        <>
          <div className="section">
            <h2>Send a Message</h2>
            <form id="send-message" onSubmit={handleSubmit}>
              <label htmlFor="email">Your Email</label>
              <input
                id="email"
                type="email"
                value={profile?.email}
                disabled
              ></input>
              <label htmlFor="title">Subject</label>
              <input
                id="title"
                type="text"
                value={title}
                required
                onChange={(event) => {
                  setTitle(event.target.value);
                }}
              />
              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                value={message}
                required
                rows="10"
                onChange={(event) => {
                  setMessage(event.target.value);
                }}
              ></textarea>
              <p className="remark">
                Please describe your request / suggestion / comment above.{" "}
                <br />
                We are trying our best to respond as soon as possible.
              </p>
              <LoadingButton
                type="submit"
                disabled={disabled}
                color="primary"
                variant="contained"
              >
                Send
              </LoadingButton>
            </form>
          </div>
        </>
      )}
      {authed && messageSent && (
        <div className="section">
          <p className="bigger">Thank you for contacting us!</p>
        </div>
      )}
      {!authed && (
        <div className="section">
          <p>
            Send us an email at{" "}
            <a href="mailto:hello@fudopia.com">
              <strong>hello@fudopia.com</strong>
            </a>
          </p>
        </div>
      )}
    </div>
  );
}

export default Contact;
